// Boshliq «Menejer huquqlari» (2026-09-14): komponent BO'LMAGAN joylar (data.tsx ustun render'lari) uchun huquq —
// localStorage'dagi user (permissions login va checkSession bilan yangilanadi). Komponentlarda hooks/useModulePerm ishlating.
import { modulePermission } from "./hasPermission"
import { roleAllowsFeature } from "./roleColumns"

export const userSync = (): any => { try { return JSON.parse(localStorage.getItem("user") || "null") } catch { return null } }
/** modulePermission (= usePermission) — oddiy funksiya (hook emas), shuning uchun render ichida ham ishlaydi */
export const permSync = (moduleCode: string) => modulePermission(userSync(), moduleCode)
export const featureSync = (moduleCode: string, key: string) => roleAllowsFeature(userSync(), moduleCode, key)
